export default __webpack_public_path__ + "static/media/PROFIL PORTFOLIO ASH11.d23e6a9c.png";